var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "ui large form",
      attrs: { "data-vv-scope": _vm.formScope },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.saveSocialNumber(_vm.formScope)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "field required",
          class: { error: _vm.errors.has(_vm.formScope + ".social_number") }
        },
        [
          _c("label", { attrs: { for: "social_number" } }, [
            _vm._v(
              _vm._s(
                _vm.$t("pages.profile.settings.profile.form.social_number")
              )
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ui input corner labeled" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.social_number,
                  expression: "form.social_number"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|numeric",
                  expression: "'required|numeric'"
                }
              ],
              attrs: {
                type: "text",
                name: "social_number",
                "data-vv-as": _vm.$t(
                  "pages.profile.settings.profile.form.social_number"
                )
              },
              domProps: { value: _vm.form.social_number },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "social_number", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _vm.errors.has(_vm.formScope + ".social_number")
            ? _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(
                  _vm._s(_vm.errors.first(_vm.formScope + ".social_number"))
                )
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui corner label" }, [
      _c("i", { staticClass: "asterisk icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77e265aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77e265aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/setup/SocialNumberSetup.vue
// module id = wxLI
// module chunks = 1